import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Field, FieldArray, reset } from 'redux-form'
import { Grid, Row, Col, Panel, ButtonToolbar, Button, DropdownButton, MenuItem, FieldGroup, Input } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Selection from '../Common/selection'
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import { Link } from 'react-router';
import { Translate, Localize, I18n } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import ConfirmActionModal from '../Common/confirmActionModal';
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isMyumyu = (ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/')
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isJML= 
  ROOT_API_URL === "https://jml-scm.truckxi.com/api/" ||
  ROOT_URL === "https://jml-scm.truckxi.com/api/";
  const isLO = ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || ROOT_URL === 'https://lonni-scm.truckxi.com/api/';

let renderRadios = props => {
    const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'marginRightLabel', 'marginH4Style')
    return (
      <ButtonToolbar className="payment-type-buttons">
        <Button bsStyle="primary" type="button">
          <div className="radio">
            <label for="notPaid-payment-type">
              <input {...props.input} id="notPaid-payment-type" type="radio" value="Not Paid" name="paymentTypeRadios" checked={props.input.value === "Not Paid" || !(props.input)}/>
              <Translate value="not_paid" />
            </label>
          </div>
        </Button>
        <Button bsStyle="primary" type="button">
          <div className="radio">
            <label for="cash-payment-type">
              <input {...props.input} id="cash-payment-type" type="radio" value="cash"
               name="paymentTypeRadios" checked={props.input.value === "cash"}/>
              <Translate value="cash" />
            </label>
          </div>
        </Button>
        <Button bsStyle="primary" type="button">
          <div className="radio">
            <label for="credit-payment-type">
              <input {...props.input} id="credit-payment-type" type="radio" value="credit_card" name="paymentTypeRadios" checked={props.input.value === "credit_card"}/>
              <Translate value="credit_card" />
            </label>
          </div>
        </Button>
        <Button bsStyle="primary" type="button">
          <div className="radio">
            <label for="check-payment-type">
              <input {...props.input} id="check-payment-type" type="radio" value="check"
               name="paymentTypeRadios" checked={props.input.value === "check"}/>
              <Translate value="check" />
            </label>
          </div>
        </Button>
      </ButtonToolbar>
    )
}

const sortByLineID = (a, b) => parseFloat(a.SalesOrderLine_id) - parseFloat(b.SalesOrderLine_id);

class RowRenderer extends Component {
   render() {
     return (<div onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>)
   }

}

RowRenderer.PropTypes = {
    onDoubleClick: React.PropTypes.func
};


class SalesShippingModal extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
          // Control state of Modal
          confirmActionOpen: false,
          setWeightOpen: false,

          orderNum: null,
          numInputFields: 0,
          totalLoaded: null,
          rowChosen: null,
          currentRow: null,
          currentTable: null,

          salesOrders: {
            rows: [],
            sortColumn: null,
            sortDirection: null
          },

          products: {
            rows: [],
            sortColumn: null,
            sortDirection: null
          },

          selectedRowIdx: 0,
          selectedQty: '',
        }

        this.openSetWeight = this.openSetWeight.bind(this);
        this.closeSetWeight = this.closeSetWeight.bind(this);
        this.openAction = this.openAction.bind(this);
        this.closeAction = this.closeAction.bind(this);
        this.moveOff = this.moveOff.bind(this);
        this.moveTo = this.moveTo.bind(this);
        this.quickMove = this.quickMove.bind(this);
    }

    componentDidMount() {
      if(this.props.InvoiceNum) {
        if (isABC) {
          let salesOrders = {...this.state.salesOrders, rows: this.props.rows};
          let products = { ...this.state.products, rows: this.props.salesOrderDetail.Sales_Invoice_Lines.map(line => ({
            ...line,
            Quantity: `${line.Quantity}/${line.LoadedQuantity}`,
            LoadedQuantity: 0,
          })) };
          this.setState({ salesOrders, products });
        } else {
          this.props.fetchSalesInvoiceDetail(this.props.InvoiceNum, "InvoiceNum");
        }
      }
      else {
        let salesOrders = {...this.state.salesOrders, rows: this.props.rows};
        this.setState({ salesOrders });
        this.props.setValue('salesShippingModal', 'PaymentType', 'Not Paid');
        this.props.setValue('salesShippingModal', 'InvoiceShipDate', null); //new Date()
      }
      // this.props.fetchSalesOrdersByDate(this.formatDate(new Date));
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.PaymentType && nextProps.PaymentType != this.props.PaymentType) {
        this.props.convertingToInvoiceReset();
        this.props.updateSalesInvoiceReset();
      }
      if(nextProps.salesOrderDetail && nextProps.salesOrderDetail != this.props.salesOrderDetail) {
        let sales_Invoice_Lines = nextProps.salesOrderDetail.Sales_Invoice_Lines
        let products = { ...this.state.products, rows: sales_Invoice_Lines };
        let salesOrders = {...this.state.salesOrders, rows: this.props.rows};
        let leftRows = [];
        salesOrders.rows.map(r => {
          let index = _.findIndex(sales_Invoice_Lines, {'Index': r.Index })
          if(index == -1) {
            leftRows.push(r);
          }
        })
        salesOrders.rows = leftRows;
        salesOrders.rows.sort(sortByLineID);
        this.setState({products, salesOrders});
      }

      if(nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
        this.setState({ PdfFrameLoaded: false });
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
        return false;
      }

      return true;
    }

    closeSetWeight() {
      this.setState({setWeightOpen: false}, () => {if (this.state.salesOrders.rows.length) ReactDOM.findDOMNode(this.refs['quickLoader'].refs.input).focus();});
    }

    openSetWeight() {
      this.setState({setWeightOpen: true});
    }

    openAction() {
      this.setState({confirmActionOpen: true});
    }

    closeAction() {
      this.setState({confirmActionOpen: false});
    }

    moveOff(row) {
      let salesOrders = {...this.state.salesOrders};
      salesOrders.rows.push(row);
      salesOrders.rows.sort(sortByLineID);
      let products = {...this.state.products};
      let index = _.findIndex(products.rows, {'Index': row.Index});
      if(index > -1)
        products.rows.splice(index, 1);
      this.setState({products, salesOrders, selectedRowIdx: 0, selectedQty: ''})
      this.props.convertingToInvoiceReset();
      this.props.updateSalesInvoiceReset();
    }

    moveTo(row) {
      let products = {...this.state.products};
      products.rows.push(row);
      products.rows.sort(sortByLineID);
      let rows = Data.Selectors.getRows(this.state.salesOrders);
      let salesOrders = {...this.state.salesOrders, rows: rows};
      let index = _.findIndex(salesOrders.rows, {'Index': row.Index});
      let newRowIdx = parseFloat(this.state.selectedRowIdx);
      if(index > -1)
        salesOrders.rows.splice(index, 1);
      if (newRowIdx >= salesOrders.rows.length-1){
        newRowIdx = salesOrders.rows.length - 1;
      }
      this.setState({products, salesOrders, selectedRowIdx: newRowIdx, selectedQty: ''})
      this.props.convertingToInvoiceReset();
      this.props.updateSalesInvoiceReset();
    }

    quickMove(row) {
      let products = {...this.state.products};
      products.rows.sort(sortByLineID);
      let index = _.findIndex(products.rows, {'Index': row.Index});
      products.rows[index].TotalNetWeight = row.TotalNetWeight;
      products.rows[index].TotalPrice = row.TotalPrice;
      this.setState({products});
      // this.props.convertingToInvoiceReset();
      // this.props.updateSalesInvoiceReset();
    }

    formatDate(date) {
      var formattedDate;
      if (date.getMonth() < 10) {
        formattedDate = '0' + (parseInt(date.getMonth())+1);
      } else {

        // TURN THESE TO STRINGS
        formattedDate = String(parseInt(date.getMonth()+1));
      }

      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += String(date.getDate());
      }

      formattedDate += String(date.getFullYear());
      return formattedDate;
    }

    createInvoice(isPartial) {
      let rows = this.state.products.rows;
      if (isABC) {
        rows = rows.filter(row => row.LoadedQuantity)
      }
      this.props.convertToInvoice(this.props.currentSalesOrder.SalesOrder_id, rows, this.props.PaymentType, this.props.PaymentNum, isPartial, this.props.InvoiceShipDate);
    }

    autoLoad() {
      // let productRows = [...this.state.products.rows];
      let salesOrders = {...this.state.salesOrders};
      let products = {...this.state.products};
      salesOrders.rows = salesOrders.rows.map(r => {
        if(r.ProductType != 'Non-Fixed') {
          r.LoadedQuantity = r.Quantity;
          r.TotalNetWeight = ((parseFloat(r.LoadedQuantity) || 0)*(parseFloat(r.NetWeight) || 0)).toFixed(2)
          products.rows.push(r);
          return null
        }
        else{
          if (isJML) {
            r.LoadedQuantity = r.Quantity;
            r.TotalNetWeight = ((parseFloat(r.LoadedQuantity) || 0)*(parseFloat(r.PackageSize_1) || 0)).toFixed(2)
            r.Weights = Array(r.Quantity).fill(parseFloat(r.PackageSize_1));
            products.rows.push(r);
            return null
          }
          return r;
        }
      })
      salesOrders.rows = salesOrders.rows.filter((obj)=>{
        return obj !== null
      })
      products.rows.sort(sortByLineID);
      // productRows.map(row => {
      //   if (row.ProductType == "Fixed") {
      //     if (row.LoadedQuantity == 0) {
      //       row.LoadedQuantity = row.Quantity;
      //     }
      //   }
      // });
      //
      // let products = {...this.state.products, rows: productRows};
      this.setState({ products, salesOrders });
      this.props.convertingToInvoiceReset();
      this.props.updateSalesInvoiceReset();
    }

    load(Index) {
            // let productRows = [...this.state.products.rows];
      let salesOrders = {...this.state.salesOrders};
      let products = {...this.state.products};
      let isNonFixed = false;
      salesOrders.rows = salesOrders.rows.map(r => {
        if(r.Index == Index && (r.ProductType == 'Fixed' || r.ProductType == 'Per-Pound')) {
          r.LoadedQuantity = parseFloat(roundTo(this.state.selectedQty, 2));
          r.TotalNetWeight = parseFloat(((parseFloat(r.LoadedQuantity) || 0)*(parseFloat(r.NetWeight) || 0)).toFixed(2));
          products.rows.push(r);
          return null;
        } else if (r.Index == Index && r.ProductType == 'Non-Fixed'){
          r.LoadedQuantity = parseFloat(roundTo(this.state.selectedQty, 2));
          isNonFixed = true;
          return r;
        }
        else{
          return r;
        }
      })

      let index = 0;
      if (!isNonFixed){
        salesOrders.rows = salesOrders.rows.filter((obj)=>{
          return (obj !== null && obj !== undefined)
        })
      } else {
        for (let i = 0; i < salesOrders.rows.length; i++){
          if( salesOrders.rows[i].Index == Index )
            index = i;
        }
        this.setState({ currentRow: index, currentTable: 'salesOrders', setWeightOpen: true });
      }

      // let products = {...this.state.products, rows: productRows};
      let newRowIdx = parseFloat(this.state.selectedRowIdx);
      if (newRowIdx >= salesOrders.rows.length-1){
        newRowIdx = salesOrders.rows.length - 1;
      }
      //will need to put this somewhere else
      this.setState({ products, salesOrders, selectedQty: '', selectedRowIdx: newRowIdx});
      this.props.convertingToInvoiceReset();
      this.props.updateSalesInvoiceReset();
    }

    checkRows(isPartial) {
      if (isTN && !this.props.InvoiceShipDate) {
        alert("Please select a Ship Date to save.");
        return;
      }
      let valid = true;
      let {salesInvoiceDetail, convertToInvoiceSuccess} = this.props;
      if (!isABC) {
        this.state.products.rows.map(row => {
          if (row.LoadedQuantity == 0) {
            this.setState({ confirmActionOpen: true });
            valid = false;
          }
        });
      }
      if (isABC && this.props.InvoiceNum && !convertToInvoiceSuccess) {
        this.createInvoice(isPartial);
        return;
      }
      if (valid && !this.props.InvoiceNum && !convertToInvoiceSuccess){
        this.createInvoice(isPartial);
      }else if (valid){
        let update = {};
        update.Sales_Invoice_Lines =  this.state.products.rows;
        update.DocumentDate = new Date;
        if (salesInvoiceDetail && salesInvoiceDetail.OrderDate != null) {
          update.OrderDate = salesInvoiceDetail.OrderDate;
        }
        let SalesInvoice_id = (salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id) || (convertToInvoiceSuccess.SalesInvoice_id);
        let SaleStatus = (salesInvoiceDetail && salesInvoiceDetail.SaleStatus) || (convertToInvoiceSuccess.SaleStatus);
        this.props.updateSalesInvoice(update, SaleStatus.toLowerCase(), SalesInvoice_id, this.props.PaymentType, this.props.PaymentNum);
      }
    }

    returnTotalWeight(totalWeight, weights) {
      let currentRow = this.state[this.state.currentTable].rows[this.state.currentRow];
      currentRow.TotalNetWeight = parseFloat(totalWeight);
      currentRow.TotalPrice = parseFloat(roundTo(((parseFloat(totalWeight) || 0)*(parseFloat(currentRow.UnitPrice) || 0)), 2).toFixed(2));
      currentRow.Weights = weights;
      if(this.state.currentTable == "salesOrders") {
        this.moveTo(currentRow);
      } else {
        this.quickMove(currentRow);
      }
    }

    renderSalesOrderSelection() {
      let that = this;
      if (this.props.salesOrdersIsLoading && !this.props.salesOrdersError) return <Spinner/>
      else if (this.props.salesOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesOrdersError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          let tableHeight = (window.innerHeight < 900) ? 387 : 387;

          const getRows = () => {
              return Data.Selectors.getRows(this.state.salesOrders);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var salesOrders = {...this.state.salesOrders, sortColumn: sortColumn, sortDirection: sortDirection};
              this.setState({ salesOrders });
          }

          const onRowSelect = rows => {
              var salesOrder = {...this.state.salesOrders, selectedRows: rows};
              this.setState({ salesOrders });
          }

          const onRowClick = (rowIdx, row) => {
            this.props.fetchSalesOrderDetail(row.SalesOrder_id);
            this.setState({ orderNum: row.SONum });
          }

          function onDoubleClick(e) {
            this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
          }


          const handleRowUpdated = e => {
              let rows = getRows();
              Object.assign(rows[e.rowIdx], e.updated);
              let loadedQuantity = parseFloat(rows[e.rowIdx].LoadedQuantity) || 0;
              let unitPrice = parseFloat(rows[e.rowIdx].UnitPrice) || 0;
              let netWeight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
              if (rows[e.rowIdx].ProductType == "Fixed") {
                rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
                rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * unitPrice), 2).toFixed(2);
              }
              if (rows[e.rowIdx].ProductType == "Per-Pound") {
                rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
                rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * netWeight * unitPrice), 2).toFixed(2);
            }
              let salesOrders = { ...this.state.salesOrders, rows: rows }
              // this.setState({ salesOrders });
              this.setState({
                salesOrders,
                totalLoaded: rows[e.rowIdx].LoadedQuantity,
                rowChosen: rows[e.rowIdx].SalesOrderLine_id,
                currentRow: e.rowIdx,
                currentTable: "salesOrders"
              }, () => {
                if(rows[e.rowIdx].ProductType == "Non-Fixed") {
                  if(!isJML) {
                    this.setState({setWeightOpen: true})
                  } else {
                    const totalWeight = rows[e.rowIdx].PackageSize_1 * loadedQuantity;
                    const Weights = [];
                    for(let i = 0; i < loadedQuantity; i++) {
                      Weights.push(parseFloat(rows[e.rowIdx].PackageSize_1))
                    }
                    this.returnTotalWeight(totalWeight, Weights);
                  }
                }
              })
          }

          const IsVariableFormatter = React.createClass({
              render() {
                if (this.props.dependentValues && this.props.dependentValues.ProductType == "Non-Fixed") {
                  return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
                } else if (this.props.dependentValues && this.props.dependentValues.ProductType == 'Per-Pound') {
                  return <span>{this.props.value} <label className='label label-primary'><Translate value="per_pound" /></label></span>;
                }
                return <span>{this.props.value} </span>
              }
          });

          // Column difinition
          var RowRenderer2 = React.createClass({
           render: function() {
            if (that.state.salesOrders.rows.length && that.state.salesOrders.rows[parseFloat(that.state.selectedRowIdx)].Index  === this.props.row.Index)
              return (<div style={{color: 'blue'}} onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
            return (<div onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
           }
          });

          const columns = [
            ...(!isLO) ? [{
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 80
            }] : [],
            ...isAFM ? [{
              key: 'Barcode',
              name: <Translate value="barcode" />,
              resizable: true,
              sortable: true,
              width: 100,
            }]: [{
              key: 'RefNum',
              name: <Translate value="ref_num" />,
              resizable: true,
              sortable: true,
              width: isLO ? 160:80,
            },],
            ...isAFM ? [{
              key: 'Brand',
              name: <Translate value="brand" />,
              resizable: true,
              sortable: true,
              width: 100,
            }]: [],
            {
              key: 'Name',
              name: <Translate value="name" />,
              resizable: true,
              sortable: true,
              width: 160,
            },
            {
              key: 'Description',
              name: <Translate value="desc" />,
              resizable: true,
              sortable: true,
              width: 95,
            },
            {
              key: 'Quantity',
              name: <Translate value="qty" />,
              resizable: true,
              sortable: true,
              formatter: IsVariableFormatter,
              width: 100,
              getRowMetaData: (row) => row,
            },
            {
              key: 'LoadedQuantity',
              name: <Translate value="loaded_qty" />,
              resizable: true,
              sortable: true,
              width: 100,
              editable: true,
            },
            ...(isLO) ? [{
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 80
          }] : [],
          ]

          return (
              <Row><Col xs={ 12 }><div style={{ maxWidth: '100%' }} id="SalesShippingModal-dataGrid1">
                  <ReactDataGrid
                      rowRenderer={<RowRenderer2 onDoubleClick={this.moveTo}/>}
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={35}
                      rowGetter={rowGetter}
                      rowsCount={getSize()}
                      enableCellSelect={true}
                      onRowUpdated={handleRowUpdated}
                      minHeight={tableHeight}
                      onRowSelect={onRowSelect}
                      />
              </div></Col></Row>

          )
      }
    }

    renderSalesOrderDetail() {
        let that = this;
        if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return <Spinner/>
        else if (this.props.salesOrderError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesOrderError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 430 : 430;

            const getRows = () => {
                return Data.Selectors.getRows(this.state.products);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var products = {...this.state.products, sortColumn: sortColumn, sortDirection: sortDirection};
                this.setState({products});
            }

            function onDoubleClick(e) {
              this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
            }


            const handleRowUpdated = e => {
                let rows = getRows();
                Object.assign(rows[e.rowIdx], e.updated);
                let loadedQuantity = parseFloat(rows[e.rowIdx].LoadedQuantity) || 0;
                let unitPrice = parseFloat(rows[e.rowIdx].UnitPrice) || 0;
                let netWeight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
                if (rows[e.rowIdx].ProductType == "Fixed") {
                  rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
                  rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * unitPrice), 2).toFixed(2);
                }
                if (rows[e.rowIdx].ProductType == "Per-Pound") {
                  rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
                  rows[e.rowIdx].TotalPrice = roundTo((loadedQuantity * netWeight * unitPrice), 2).toFixed(2);
                }
                let products = { ...this.state.products, rows: rows }
                this.setState({
                  products,
                  totalLoaded: rows[e.rowIdx].LoadedQuantity,
                  rowChosen: rows[e.rowIdx].SalesOrderLine_id,
                  currentRow: e.rowIdx,
                  currentTable: "products"
                }, () => {
                  if(rows[e.rowIdx].ProductType == "Non-Fixed") {
                    if(!isJML) {
                      this.setState({setWeightOpen: true})
                    } else {
                      const totalWeight = rows[e.rowIdx].PackageSize_1 * loadedQuantity;
                      const Weights = [];
                      for(let i = 0; i < loadedQuantity; i++) {
                        Weights.push(parseFloat(rows[e.rowIdx].PackageSize_1))
                      }
                      this.returnTotalWeight(totalWeight, Weights);
                    }
                  }
                })
                this.props.convertingToInvoiceReset();
                this.props.updateSalesInvoiceReset();
            }

            // var RowRenderer = React.createClass({
            //
            //  render: function() {
            //    return (<div onClick={()=>{console.log("on click, move")}}><ReactDataGrid.Row ref="row" {...this.props} onDoubleClick={this.props.onDoubleClick} /></div>)
            //  }
            // });
            //
            // RowRenderer.PropTypes: {
            //   onDoubleClick: React.PropTypes.func
            // }

            // Custom Formatter component
            const IsVariableFormatter = React.createClass({
                render() {
                  if (this.props.dependentValues && this.props.dependentValues.ProductType == "Non-Fixed") {
                    return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
                  } else if (this.props.dependentValues && this.props.dependentValues.ProductType == 'Per-Pound') {
                    return <span>{this.props.value} <label className='label label-primary'><Translate value="per_pound" /></label></span>;
                  }
                  return <span>{this.props.value} </span>
                }
            });

            // Column difinition

            const columns = [
              ...(!isLO) ? [{
                  key: 'ProductNum',
                  name: <Translate value="prod_num" />,
                  resizable: true,
                  sortable: true,
                  width: 80
              }] : [],
              ...isAFM ? [{
                key: 'Barcode',
                name: <Translate value="barcode" />,
                resizable: true,
                sortable: true,
                width: 100,
              }]: [{
                key: 'RefNum',
                name: <Translate value="ref_num" />,
                resizable: true,
                sortable: true,
                width: isLO ? 160 : 80,
              },],
              ...isAFM ? [{
                key: 'Brand',
                name: <Translate value="brand" />,
                resizable: true,
                sortable: true,
                width: 100,
              }]: [],
              {
                key: 'Name',
                name: <Translate value="name" />,
                resizable: true,
                sortable: true,
                width: 100
              },
              {
                key: 'Description',
                name: <Translate value="desc" />,
                resizable: true,
                sortable: true,
                width: 100,
              },
              {
                key: 'PackageSize',
                name: <Translate value="pkg_type" />,
                resizable: true,
                sortable: true,
                width: 80,
              },
              {
                key: 'Quantity',
                name: <Translate value="qty" />,
                resizable: true,
                sortable: true,
                width: 110,
                formatter: IsVariableFormatter,
                getRowMetaData: (row) => row,
              },
              {
                key: 'LoadedQuantity',
                name: <Translate value="loaded_qty" />,
                resizable: true,
                sortable: true,
                width: 100,
                editable: true,
              },
              {
                key: 'TotalNetWeight',
                name: <Translate value="total_wt" />,
                resizable: true,
                sortable: true,
                width: 100,
              },
              {
                key: 'TotalPrice',
                name: <Translate value="total_dollarsign" />,
                resizable: true,
                sortable: true,
                width: 100,
              },
              ...(isLO) ? [{
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 80
            }] : [],
            ]

            if (isABC) {
              const index1 = _.findIndex(columns, { key: "PackageSize" });
              const index2 = _.findIndex(columns, { key: "LoadedQuantity" });
              const index3 = _.findIndex(columns, { key: "Description" });

              columns.splice(index1, 1);
              columns.splice(index2, 1);
              columns.splice(index3, 1, {
                key: 'Description',
                name: <Translate value="desc_editable" />,
                resizable: true,
                sortable: true,
                width: 95,
                editable: true,
              });
            }

            return (
                <Row><Col xs={ 12 }><div style={{ maxWidth: '100%' }} id="SalesShippingModal-dataGrid2">
                    <ReactDataGrid
                        rowKey='Product_id'
                        rowRenderer={<RowRenderer onDoubleClick={this.moveOff}/>}
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={35}
                        enableCellSelect={true}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={tableHeight}
                        onRowUpdated={handleRowUpdated}
                        />
                </div></Col></Row>

            )
        }
    }

    IFrameIsLoaded = () => {
      if (!this.state.PdfFrameLoaded) {
        var pdfFrame = window.frames["Pdf"];
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ PdfFrameLoaded: true });
      }
    }

    renderIFrame() {
      if (this.props.salesInvoicePdf) {
        var file = window.URL.createObjectURL(this.props.salesInvoicePdf);
        return (
            <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
    }

    renderPrint() {
      let pk = this.props.currentSalesOrder.SalesInvoice_id || (this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.SalesInvoice_id) || (this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.SalesInvoice_id);
      if(!pk)
        return;
      let shipping_url = ROOT_URL + 'v1/sale/printinvoice/' + pk + "?Bearer=" + localStorage.getItem('token');
      return(
        <Button
          bsStyle='primary'
          className="position-print-invoice-btn-relative"
          disabled={this.props.requestingSalesInvoicePdf}
          type='button'
          onClick={() => {
            this.props.printSalesInvoice(pk);
          }}
        >
          <em className='fa fa-print' /><Translate value="print_invoice" />
        </Button>
      )
    }

    renderPaymentNum() {
      if(this.props.PaymentType && this.props.PaymentType == "Check") {
        return (
          <Row className="position-relative">
            <Col xs={ 12 }><label><Translate value="check_no" /></label></Col>
            <Col xs={ 12 }><Field name="PaymentNum" component={ InputField } placeholder="Enter check no."  /></Col>
          </Row>
        )
      }
      else {
        return
      }
    }

    keepLoaded = (oldLoaded) => {
      let products = {...this.state.products};
      if (oldLoaded) {
        products.rows[this.state.currentRow].LoadedQuantity = oldLoaded;
      }
      this.setState({ products });
    }

    handleKeyPress = (event) => {
      if(event.charCode == 13 && parseFloat(this.state.selectedQty) && this.state.selectedQty){
        event.preventDefault();
        let rows = Data.Selectors.getRows(this.state.salesOrders);
        const { selectedRowIdx } = this.state;
        let salesOrders = { ...this.state.salesOrders, rows: rows }
        this.setState({
          salesOrders,
          totalLoaded: this.state.selectedQty || 0,
          rowChosen: rows[parseFloat(selectedRowIdx)].SalesOrderLine_id,
          currentRow: parseFloat(selectedRowIdx),
          currentTable: 'salesOrders',
        }, () => {
          this.load(rows[selectedRowIdx].Index);
        })
      } else if (event.charCode == 13){
        let rows = Data.Selectors.getRows(this.state.salesOrders);
        const { selectedRowIdx } = this.state;
        let newRowIdx = 0;
        if (rows.length && parseFloat(selectedRowIdx) < (rows.length-1))
          newRowIdx = parseFloat(selectedRowIdx) + 1;
        this.setState({
          selectedRowIdx: newRowIdx,
          selectedQty: '',
          totalLoaded: this.state.selectedQty || 0,
          rowChosen: rows[parseFloat(selectedRowIdx)].SalesOrderLine_id,
          currentRow: parseFloat(selectedRowIdx),
          currentTable: 'salesOrders'
        });
      }
    }

    handleChange = event => {
      this.setState({selectedQty: event.target.value});
    }

    renderQuickLoader = () =>{
      let rowName = '';
      let rows = Data.Selectors.getRows(this.state.salesOrders);
      const { selectedQty, selectedRowIdx } = this.state;
      if (rows.length && selectedRowIdx < rows.length && !isLO){
        rowName = (rows[parseFloat(selectedRowIdx)].ProductNum || "")+ "  " + (rows[parseFloat(selectedRowIdx)].Name || "") +  "  " + (rows[parseFloat(selectedRowIdx)].Description || "");
      } 
      if (rows.length && selectedRowIdx < rows.length && isLO){
        rowName = (rows[parseFloat(selectedRowIdx)].RefNum || "")+ "  " + (rows[parseFloat(selectedRowIdx)].Name || "") +  "  " + (rows[parseFloat(selectedRowIdx)].Description || "");
      } 
      if (rowName.length && rowName.length >= 54){
        rowName = rowName.substring(0, 53);
        rowName += '...';
      }
      return (
        <Panel className='quick-loader-panel'>
          {
            (rows.length) ?
              <Col xs={ 9 } >
                <label className="quick-loader-label">
                  <span className="quick-loader-text">{rowName}</span>
                </label>
              </Col>:
              <Col style={{ 'display': 'block', 'text-align': 'center'}}>
                <label className="quick-loader-label">
                  <span className="quick-loader-text" style={{ 'color': '#5cb85c' }}><Translate value="msg_products_loaded_click_save_to_complete" /></span>
                </label>
              </Col>
          }
          {
          (rows.length) ?
            <Col xs={ 3 } className="quick-loader-input">
              <Input type="number" autoFocus placeholder={I18n.t('loaded_qty')} ref='quickLoader' withRef={true} value={this.state.selectedQty} onChange={this.handleChange} onKeyPress={(event) => {
                  this.handleKeyPress(event)
                }} />
            </Col>:
            <span/>
          }
        </Panel>
      )
    }

    render() {
      const { savings, discount, taxRate } = this.props;

      let createDialogStyle = {
          width: '500px',
          height: '600px',
          top: '45%',
          marginLeft: '-10%',
      };

      let totalUnit = 0;
      let totalUnitProducts = 0;
      let totalNetWeight = 0;
      let totalPrice = 0;
      let finalPrice = 0;
      let salesOrdersRows = this.state.salesOrders.rows || [];
      let productsRows = this.state.products.rows || [];
      let currentWeights = (productsRows[this.state.currentRow]) ? this.state.products.rows[this.state.currentRow].Weights : [];
      let weightsTitle = 'Set Product Weights: ';
      let totalTax = 0;
      const { currentTable, currentRow } = this.state;
      if(currentTable && this.state[currentTable].rows.length && this.state[currentTable].rows[currentRow]){
        weightsTitle = this.state[currentTable].rows[currentRow].ProductNum + ' ' + this.state[currentTable].rows[currentRow].Name;
      }
      salesOrdersRows.map(r => {
        totalUnit += parseFloat(r.Quantity) || 0
      })
      productsRows.map(r => {
        totalUnitProducts += parseFloat(r.LoadedQuantity) || 0
        totalNetWeight += parseFloat(r.TotalNetWeight) || 0
        totalPrice += parseFloat(r.TotalPrice) || 0
        if (r.IsTaxable === true) {
          totalTax += r.TotalPrice*(taxRate/100);
        }
      })

      totalNetWeight = parseFloat(Math.round(totalNetWeight*100)/100).toFixed(2)
      if (isMyumyu || isAFG || isWecom || isAFM) {
        if (discount === 0  && savings > 0) {
          finalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax - savings, 2)).toFixed(2);
        } else if (discount > 0) {
          finalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax - (totalPrice*(discount/100)), 2)).toFixed(2);
        } else {
          finalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax, 2)).toFixed(2);
        }
        totalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery), 2)).toFixed(2);
      } else {
        totalPrice = parseFloat((Math.round(totalPrice*100)/100)).toFixed(2);
      }
      // isMyumyu ? totalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery), 2)).toFixed(2) : totalPrice = parseFloat((Math.round(totalPrice*100)/100)).toFixed(2)
      return (
          <ContentWrapper>
            <Row className="success-message">
              { (this.props.convertingToInvoice || this.props.salesInvoiceIsUpdating) && <div><Spinner/><Translate value="uploading" /></div> }
              { ((this.props.convertToInvoiceSuccess && !this.props.refreshConvertingToInvoice) || this.props.salesInvoiceUpdated) && !(this.props.convertingToInvoice || this.props.salesInvoiceIsUpdating) &&
                <div className="alert alert-success">
                  <span><Translate value="saved" /> </span>
                  <span><Translate value="your_sales_invoice_no_is" /> </span>
                  {(this.props.salesInvoiceUpdated && this.props.salesInvoiceUpdated.InvoiceNum)||(this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.InvoiceNum)}
                </div>}
              { this.props.convertToInvoiceFailure && <div className="alert alert-danger marginTopStyle" >{this.props.convertToInvoiceError}</div> }
              { this.props.salesInvoiceUpdateError && <div className="alert alert-danger marginTopStyle" >{this.props.salesInvoiceUpdateError.detail}</div> }
            </Row>
            <Row>
              <Col xs={ 5 }>
                <h3><Translate value="sales_order_no" />: {this.props.currentSalesOrder.SONum}</h3>
              </Col>
            {isTN &&
              <div>
                <Col xs={2}>
                  <h4 className="filter-title"><Translate value="ship_date" /><span style={{color:'red'}}>*</span><span className="colon">:</span></h4>
                </Col>
                <Col xs={2} style={{ paddingTop: '10px' }}>
                  <Field component={DatePicker} name="InvoiceShipDate"></Field>
                </Col>
              </div>
            }
            </Row>
            <Row className="set-height">
              <Col xs={ 5 }>
              {!isTN &&
                <h4><Translate value="cust_name" />: {this.props.currentSalesOrder.Deliver_CustomerName}</h4>
              }
              {isTN &&
                <h4><Translate value="customer" />: {this.props.currentSalesOrder.Deliver_CustomerName} (CPO: {this.props.currentSalesOrder.CPONum})</h4>
              }
              </Col>
              <Col xs={ 1 }>
                <h4 className="filter-title"><Translate value="payment" /><span className="colon">:</span></h4>
              </Col>
              <Col xs={ 4 }>
                <Field name="PaymentType" component={ renderRadios }  />
              </Col>
              <Col xs={ 2 }>
                {this.renderPaymentNum()}
              </Col>
            </Row>
            <Row>
              <Col xs={ 5 }>
                {this.renderQuickLoader()}
                <Panel className="table-collapse-fix-pre">
                  <Row className="panel-toolbar">
                    <Button bsStyle="primary" type="button" style={{ marginLeft: '140px' }} onClick={() => this.autoLoad() }>
                      <em className="fa fa-mail-forward" /><Translate value="auto_load" />
                    </Button>
                    <Col xs={ 3 }>
                      <label className="marginRightLabel"><Translate value="total_prod" />:</label>
                      {this.state.salesOrders.rows.length}
                    </Col>
                    <Col xs={ 3 }>
                      <label className="marginRightLabel"><Translate value="total_unit" />:</label>
                      {totalUnit}
                    </Col>
                  </Row>
                  {this.renderSalesOrderSelection()}
                </Panel>
              </Col>
              <Col xs={ 7 }>
                <Panel className="table-collapse-fix">
                  <ButtonToolbar className="pull-right">
                    { this.renderPrint() }
                    {
                      isABC && (
                        <Button
                          bsStyle="success"
                          type="button"
                          disabled={this.props.salesOrderDetail == null || this.props.convertingToInvoice || this.props.convertToInvoiceSuccess}
                          onClick={() => this.checkRows(true) }
                        >
                          <em className="fa fa-save" /><Translate value="partial_save" />
                        </Button>
                      )
                    }
                    <Button
                      bsStyle="success"
                      type="button"
                      disabled={this.props.salesOrderDetail == null || this.props.convertingToInvoice || this.props.convertToInvoiceSuccess}
                      onClick={() => this.checkRows() }
                    >
                      <em className="fa fa-save" /><Translate value="save" />
                    </Button>
                  {/*  <Button className="btn btn-primary pull-right" onClick={() => {this.createInvoice()} }><Translate value="save" /></Button>*/}
                  </ButtonToolbar>
                  <Row>
                    <Col xs={ 10 }>
                      <Row className="panel-toolbar">
                        <Col xs={ 3 }>
                          <label className="marginRightLabel"><Translate value="total_prod" />:</label>
                          {this.state.products.rows.length}
                        </Col>
                        <Col xs={ 3 }>
                          <label className="marginRightLabel"><Translate value="total_unit" />:</label>
                          {totalUnitProducts}
                        </Col>
                        <Col xs={ 3 }>
                          <label className="marginRightLabel"><Translate value="total_weight" />:</label>
                          {totalNetWeight}
                        </Col>
                        <Col xs={ 3 }>
                          <label className="marginRightLabel"><Translate value="total_price" />:</label>
                          {/* <span className="dollar-sign">$</span><span>{totalPrice}</span> */}
                          <span className="dollar-sign">$</span><span>{finalPrice}</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={ 12 }>
                      {this.renderSalesOrderDetail()}
                    </Col>
                  </Row>
                </Panel>
              </Col>
            </Row>
            {this.renderIFrame()}
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.setWeightOpen} onCloseClicked={() => {
                this.closeSetWeight()
            } } title={weightsTitle}>
                <SetWeightModal
                  closeC={this.closeSetWeight}
                  totalLoaded={ this.state.totalLoaded }
                  rowChosen={ this.state.rowChosen }
                  returnTotalWeight={ this.returnTotalWeight.bind(this) }
                  currentTable={ this.state.currentTable }
                  keepLoaded={this.keepLoaded}
                  currentWeights={currentWeights}
                  setWeights={()=>{}}
                />
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmActionOpen} onCloseClicked={() => {
                this.closeAction()
            } } title="Confirm Action">
                <ConfirmActionModal closeC={this.closeAction} case={"quantityZero"} caseAction={this.createInvoice.bind(this)}/>
            </SkyLightStateless>
          </ContentWrapper>
      )
    }
}

export default SalesShippingModal;

function roundTo(n, digits) {
   if (digits === undefined) {
     digits = 0;
   }

   var multiplicator = Math.pow(10, digits);
   n = parseFloat((n * multiplicator).toFixed(11));
   var test =(Math.round(n) / multiplicator);
   return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesShippingModal.jsx